/**
 * Created by olga on 22.12.2025
 */

const TreasureSearchTutorial = function () {
    return new TutorialScenario(TreasureSearchTutorial.NAME, {
        manual: true,
        listSteps: TreasureSearchTutorial.listSteps,
        isAvailable: function () {
            return !cleverapps.forces.isShown(Forces.TREASURE_SEARCH);
        }
    });
};

TreasureSearchTutorial.listSteps = function () {
    return [
        TreasureSearchTutorial.waitWindowShown(),
        TreasureSearchTutorial.createOpenCellStep(0),
        TreasureSearchTutorial.createOpenCellStep(1),
        TreasureSearchTutorial.createMiningToolStep(),
        TreasureSearchTutorial.createChestsStep()
    ];
};

TreasureSearchTutorial.createOpenCellStep = function (cellIndex) {
    // a resize rebuilds the view, and the cell the finger points at is gone with it - the force
    // then holds nodes nothing can reach and takes every touch with them
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        if (!window) {
            return undefined;
        }

        const treasureSearchView = window.treasureSearchView;
        const treasureSearch = window.treasureSearch;

        const goalKey = Object.keys(treasureSearch.goals).find((key) => treasureSearch.goals[key].length === 2);
        const cellViews = treasureSearch.goals[goalKey].map((goal) => treasureSearchView.cellViews[goal.row][goal.col]);

        const force = cellIndex === 0 ? Forces.TREASURE_SEARCH : { text: Forces.TREASURE_SEARCH.text };

        return cleverapps.forces.create(cellViews[cellIndex], force, {
            highlights: [window],
            importantNodes: [treasureSearchView.field],
            onSkip: () => cleverapps.tutorial.skip()
        });
    };

    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            if (cellIndex === 0) {
                cleverapps.tutorial.on("TreasureSearchOpenAnimationFinished", this.finish.bind(this), this);
            } else {
                cleverapps.tutorial.on("TreasureSearchGoalCollected", () => {
                    this.finishTimeout = cleverapps.timeouts.setTimeout(() => {
                        this.finish();
                    }, 500);
                }, this);
            }

            this.force = createForce();

            cleverapps.tutorial.on("TreasureSearchOpen", () => {
                this.cellOpened = true;

                this.force && this.force.hideForceHints();
            }, this);

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();

                if (this.cellOpened) {
                    this.finish();
                } else {
                    this.force = createForce();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.timeouts.clearTimeout(this.finishTimeout);

            cleverapps.tutorial.startNextStep();
        }
    });
};

TreasureSearchTutorial.getChildrenByPoint = function (parent, p) {
    const list = [];

    const children = parent.getChildren();
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const rect = child.getBoundingBox();
        if (cc.rectContainsPoint(rect, p)) {
            list.push(child);
        }
    }
    return list;
};

TreasureSearchTutorial.waitWindowShown = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (window && window.name === "treasuresearchwindow") {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("window_shown", (options) => {
                if (options.windowName === "treasuresearchwindow") {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

TreasureSearchTutorial.createMiningToolStep = function () {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        if (!window) {
            return undefined;
        }

        const miningTool = window.treasureSearchView.miningTool;

        return cleverapps.forces.create(ForceView.NO_ELEMENT, { text: "TreasureSearchTutorial.Force1" }, {
            highlights: [miningTool],
            importantNodes: [miningTool],
            onSkip: () => cleverapps.tutorial.skip()
        });
    };

    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            this.force = createForce();

            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

TreasureSearchTutorial.createChestsStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            this.force = cleverapps.forces.create(ForceView.NO_ELEMENT, { text: "TreasureSearchTutorial.Force2", position: MinimalDialogue.POSITIONS.CENTER }, {
                highlights: [window],
                onSkip: () => cleverapps.tutorial.skip()
            });
            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

TreasureSearchTutorial.NAME = "treasure_search_tutorial";
